import { Skeleton, Stack } from "../ui"

function ItemSkeleton() {
  return (
    <div>
      <Stack>
        <div>
          <Stack gap="xs">
            <Skeleton className="h-4 w-[220px]" />
            <Skeleton className="h-2 w-[240px]" />
          </Stack>
        </div>
        <div>
          <Stack gap="md">
            <Skeleton className="h-3 w-[320px]" />
            <Skeleton className="h-3 w-[220px]" />
          </Stack>
        </div>
      </Stack>
    </div>
  )
}

export function TaskAnalyticsLoading() {
  return (
    <div>
      <Stack>
        <div>
          <h2 className="text-lg font-semibold text-primary-800">
            Oppgaveanalyse
          </h2>
        </div>
        <div>
          <div className="grid w-full grid-cols-4 gap-4">
            <div className="bg-white p-4 shadow-md">
              <ItemSkeleton />
            </div>
            <div className="bg-white p-4 shadow-md">
              <ItemSkeleton />
            </div>
            <div className="bg-white p-4 shadow-md">
              <ItemSkeleton />
            </div>
            <div className="bg-white p-4 shadow-md">
              <ItemSkeleton />
            </div>
          </div>
        </div>
      </Stack>
    </div>
  )
}
